import { Controller } from "@hotwired/stimulus";
import { marked } from "marked";
import DOMPurify from "dompurify";

const parser = new DOMParser();

export default class extends Controller {
  static targets = ["template", "output"];

  connect() {
    const raw = this.templateTarget.innerHTML;
    const decoded = parser.parseFromString(raw, "text/html").body.textContent;
    this.outputTarget.innerHTML = DOMPurify.sanitize(marked.parse(decoded));
  }
}
